export default __webpack_public_path__ + "static/media/jobs_active.6c2be537.svg";